import React, { useEffect, useState } from 'react'
import moment from "moment";
let SERVER_URL = process.env.REACT_APP_API_URL;
let BASE_URL = process.env.REACT_APP_APP_URL;
let token = JSON.parse(localStorage.getItem('key'));
function InOutComp({ att_date, user_id, count }) {
    const [inOut, setInOut] = useState([])
    useEffect(() => {
        getInOut(att_date, user_id)
    }, [att_date, count])

    const getInOut = async (att_date, user_id) => {
        const response = await fetch(SERVER_URL + `api/attendance/day-in-out`,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({ att_date: moment(att_date).format("YYYY-MM-DD"), user_id: user_id }),
            }).then(res => res.json())
            .then(data => {
                setInOut(data?.data)
            })
    }
    function calculateHourse(timeIn, timeOut) {
        var startTime = moment(timeIn, 'hh:mm:ss a');
        var endTime = moment(timeOut, 'hh:mm:ss a');
        var totalHours = (endTime.diff(startTime, 'hours'));
        var totalMinutes = endTime.diff(startTime, 'minutes');
        var clearMinutes = totalMinutes % 60;
        var minutformat = parseInt(clearMinutes) < 10 ? '0' + clearMinutes : clearMinutes;
        var totalHoursformat = parseInt(totalHours) < 10 ? '0' + totalHours : totalHours;
        return (totalHoursformat + " : " + minutformat);
    }
    return (
        <>
            {
                inOut?.map(item => (
                    <tr className="multiple_attend">
                        <td></td>
                        <td></td>
                        <td>
                            {item?.end_time ? item?.end_time != '00:00:00' ? <i className="icon icon-clock"></i> : '' : ''}
                            {item?.start_time != '00:00:00' ? item?.start_time ? moment(item?.start_time, 'HH:mm').format('hh:mm a').toUpperCase() : '' : '----'}
                        </td>
                        <td>
                            {item?.end_time ? item?.end_time != '00:00:00' ? <i className="icon icon-clock"></i> : '' : ''}
                            {/* {item.end_time} */}
                            {item?.end_time != '00:00:00' ? item?.end_time ? moment(item?.end_time, 'HH:mm').format('hh:mm a').toUpperCase() : '' : item.status == 0 ? '--' : ''}
                        </td>
                        <td>
                            <i className="icon icon-clock"></i>
                            {item?.end_time != '00:00:00' ? item?.end_time ? calculateHourse(item?.start_time, item?.end_time) + ' HRS' : '' : item.status == 0 ? '00:00 HRS' : ''}
                        </td>
                        <td>Close</td>
                    </tr>
                ))
            }
        </>
    )
}

export default InOutComp
